const mskProcessor = (element)=>
{
let assembledElement = ""

let lesionType=
    {
    Unexplained_bone_swelling: "an unexplained bone swelling",
    Unexplained_fracture: "an unexplained fracture",
    Unexplained_enlarging_soft_tissue_lump: "an unexp;ained soft tissue lump"
    }

let symptomKey = element["symptom"].replaceAll(" ", "_")
assembledElement += ` ${lesionType[symptomKey]}`

if (element["Site(s)"] !== "")
    {
    assembledElement += ` involving their ${element["Site(s)"]}`
    }
    if (element["Description:"] !== "")
    {
    assembledElement += ` described as ${element["Description:"]}`
    }

if (element["Present_for_several:"] !== "")
{
assembledElement += ` which has been present for several ${(element["Present_for_several:"]).toLowerCase()}`
}


return (assembledElement)
}

export default mskProcessor